export const standaloneSearchBoxStorageKey = 'coveo-standalone-search-box';
